import {createFileRoute} from '@tanstack/react-router'
// import {RegisterPartnerScreen} from "~/components/register-partner/screen-register-partner.tsx";

export const Route = createFileRoute('/register-partner/')({
  component: () => null, // <RegisterPartnerScreen />,
})
